import { module } from 'modujs'
import { ENV, FONT, CUSTOM_EVENT } from '../config'
import { whenReady } from '../utils/fonts'
import { gsap } from '../gsap'

export default class extends module {
    constructor(m) {
        super(m)

        // DOM
        this.$rail = this.el
        this.$railInner = this.$('inner')[0]
        this.$railContent = this.$('content')[0]

        // Vars
        this.isRolling = false
    }

    init() {

        if(ENV.REDUCED_MOTION) {
            return
        }

        this.set()

        // Events
        whenReady(FONT.EAGER).then(() => this.set())
        window.addEventListener(CUSTOM_EVENT.RESIZE_END, this.onResize = () => this.set())
    }

    set() {
        const railWidth = this.$rail.offsetWidth
        const railWordWidth = this.$railContent.offsetWidth
        let railInnerWidth = railWordWidth

        // Remove clones
        while (this.$railInner.children.length > 1) {
            this.$railInner.removeChild(this.$railInner.lastChild)
        }

        // Create clones
        let $clone
        while (railInnerWidth < 4 * railWidth) {
            $clone = this.$railContent.cloneNode(true)
            this.$railInner.appendChild($clone)
            railInnerWidth += railWordWidth
        }

        // Compute translateX size
        let translateX = 0
        while (translateX < railWidth) {
            translateX += railWordWidth
        }

        this.tl = gsap.fromTo(this.$railInner,
            {
                x: 0
            },
            {
                x: -translateX,
                duration: translateX/100, // Duration proportional to translate
                ease: 'none',
                repeat: -1,
                paused: true,
            })

        this.tl.progress(0.5)
    }

    updateVelocity(velocity) {

        if(ENV.REDUCED_MOTION) {
            return
        }

        if(velocity <= 0 || !this.isRolling) {
            return
        }

        velocity = 0.4 * velocity + 1

        this.tl.timeScale(velocity)
    }

    toggle(e) {

        if(ENV.REDUCED_MOTION) {
            return
        }

        this.isRolling = e.way === 'enter'

        if(!this.tl) {
            return
        }

        if(this.isRolling) {
            this.tl?.play()
        } else {
            this.tl?.pause()
        }
    }

    destroy() {

        if(ENV.REDUCED_MOTION) {
            return
        }

        // Events
        window.removeEventListener(CUSTOM_EVENT.RESIZE_END, this.onResize)
    }
}
